"use client";

import { TrialDto } from "@decibeltrade/sdk";
import { useTranslations } from "next-intl";
import { css } from "styled-system/css";
import { stack } from "styled-system/patterns";

import { Banner } from "@/components/banner";

import { TrialPositionsTable } from "./trial-positions-table";

interface SettleScreenProps {
  trial: TrialDto;
}

export function SettleScreen({ trial }: SettleScreenProps) {
  const t = useTranslations("firstTradeOnUs.details.settle");
  const isAdminReset = trial.settle_reason === "AdminReset";
  const isNeverFilled = trial.settle_reason === "NeverFilled";

  return (
    <div
      data-testid="fft-settle-screen"
      data-settle-reason={trial.settle_reason ?? "unknown"}
      className={stack({ gap: "16", w: "full" })}
    >
      {isAdminReset && (
        <div className={css({ px: "16" })} data-testid="fft-admin-reset-banner">
          <Banner variant="warning" className={css({ bg: "amber.900" })}>
            <div className={stack({ gap: "4" })}>
              <strong>{t("adminResetBadge")}</strong>
              <span>{t("adminResetExplainer")}</span>
            </div>
          </Banner>
        </div>
      )}

      {isNeverFilled && (
        <div className={css({ px: "16" })} data-testid="fft-never-filled-banner">
          <Banner variant="warning" className={css({ bg: "amber.900" })}>
            <div className={stack({ gap: "4" })}>
              <strong>{t("neverFilledBadge")}</strong>
              <span>{t("neverFilledExplainer")}</span>
            </div>
          </Banner>
        </div>
      )}

      <TrialPositionsTable trial={trial} variant="settled" />
    </div>
  );
}
